import { Text, Box, Flex, Icon, Separator } from "@chakra-ui/react";
import { IconType } from "react-icons";
import useThemeColors from "../../hooks/useThemeColors";
import useIcons from "../../hooks/useIcons";

interface Props {
  bg?: string;
  maxW?: string;
  w?: string;
  icon?: IconType;
  header: string;
  body?: string;
}

export default function Blox({ bg, maxW, w, icon, header, body }: Props) {
  const colors = useThemeColors();
  const icons = useIcons();

  const getDefaultIcon = () => {
    const headerLower = header.toLowerCase();
    if (headerLower.includes("session")) return icons.main.session;
    if (headerLower.includes("term")) return icons.main.term;
    if (headerLower.includes("class")) return icons.main.class;
    if (headerLower.includes("student")) return icons.people.student;
    if (headerLower.includes("teacher")) return icons.people.teacher;
    if (headerLower.includes("admin")) return icons.people.admin;
    return icons.utility.info;
  };

  const displayIcon = icon || getDefaultIcon();

  return (
    <Box
      bg={bg || colors.utility.alt}
      p={2}
      borderRadius={"lg"}
      borderWidth={1}
      maxW={maxW || ""}
      w={w || ""}
      transition={"300ms"}
    >
      <Flex opacity={0.5} gap={2} alignItems={"center"}>
        <Icon as={displayIcon} />
        <Text fontSize={"xs"}>{header}</Text>
      </Flex>
      <Separator my={1} />
      <Text opacity={0.5} fontSize={"sm"}>
        {body}
      </Text>
    </Box>
  );
}
